// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiClientCollection/getTableSettings', payload).then(getData);
export const get = (payload = null) => http.post('apiClientCollection/getRows', payload).then(getData);
export const getRow = (rowID) => http.get(`apiClientCollection/getRow&RowID=${rowID}`).then(getData);